import { render, staticRenderFns } from "./FormUusiSalasana.vue?vue&type=template&id=19323e6e&scoped=true&"
import script from "./FormUusiSalasana.vue?vue&type=script&lang=js&"
export * from "./FormUusiSalasana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19323e6e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19323e6e')) {
      api.createRecord('19323e6e', component.options)
    } else {
      api.reload('19323e6e', component.options)
    }
    module.hot.accept("./FormUusiSalasana.vue?vue&type=template&id=19323e6e&scoped=true&", function () {
      api.rerender('19323e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormUusiSalasana.vue"
export default component.exports